export default function Logo({ size = 36 }) {
  return (
    <img
      src="/logo.png"
      alt="NFL Survival 2026"
      width={size}
      height={size}
      style={{ objectFit: 'contain', display: 'block' }}
    />
  )
}
